"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldShowMap = exports.filterOutliers = exports.clusterPoints = void 0;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));
var _math = require("@raywhite/helpers-utils/lib/helpers/math");
/**
 * Filters out points that are more than `devs` standard deviations
 * outside the standard deviations for latitude and longitude.
 */
var filterOutliers = function (points) {
  var {
    devs = 1,
    min = 10
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // Not enough points for the standard deviation to be meaningful anyway
  if (points.length < min) return points;
  var lats = (0, _map.default)(points).call(points, _ref => {
    var {
      lat
    } = _ref;
    return lat;
  });
  var lngs = (0, _map.default)(points).call(points, _ref2 => {
    var {
      lng
    } = _ref2;
    return lng;
  });
  var avlat = (0, _math.average)(lats);
  var avlng = (0, _math.average)(lngs);
  var sdlat = (0, _math.stddev)(lats);
  var sdlng = (0, _math.stddev)(lngs);
  var minlat = avlat - sdlat * devs;
  var maxlat = avlat + sdlat * devs;
  var minlng = avlng - sdlng * devs;
  var maxlng = avlng + sdlng * devs;
  return (0, _filter.default)(points).call(points, _ref3 => {
    var {
      lat,
      lng
    } = _ref3;
    return lat >= minlat && lat <= maxlat && lng >= minlng && lng <= maxlng;
  });
};

/**
 * Cluster points together in O(N) by rounding them based on precision instead
 * of comparing distance between each pair of points O(N2).
 */
exports.filterOutliers = filterOutliers;
var clusterPoints = function (points) {
  var {
    merge,
    precision = 4
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var map = {};
  var round = val => {
    var _context;
    return (
      // eslint-disable-next-line prefer-template
      Number(Math.round((0, _concat.default)(_context = "".concat(val, "e")).call(_context, precision)) + "e-".concat(precision))
    );
  };
  return (0, _reduce.default)(points).call(points, (acc, point) => {
    var _context2;
    var {
      lat,
      lng
    } = point;
    var key = (0, _concat.default)(_context2 = "".concat(round(lat), ",")).call(_context2, round(lng));
    var seen = map[key];
    if (seen !== undefined) {
      acc[seen] = merge ? merge(acc[seen], point) : acc[seen];
      return acc;
    }
    map[key] = acc.length;
    acc.push(point);
    return acc;
  }, []);
};

// Types of listings that should show a map header
exports.clusterPoints = clusterPoints;
var mapTypes = {
  BUS: true,
  COM: true,
  HOL: true,
  REN: true,
  RUR: true,
  SAL: true
};

// Figure out whether to show a map given the typeCode(s) being used
var shouldShowMap = typeCode => {
  if (!typeCode) return true;
  var typeCodes = (0, _isArray.default)(typeCode) ? typeCode : [typeCode];
  return (0, _reduce.default)(typeCodes).call(typeCodes, (mappable, code) => mappable || mapTypes[code], false);
};
exports.shouldShowMap = shouldShowMap;